// src/components/PinisiKata/PinisiStartScreen.js
import React from 'react';
import styles from './PinisiKata.module.css';
import PinisiShipSVG from './PinisiShipSVG'; // Impor komponen SVG
import { ACTIONS } from './PinisiKataGame'; // Impor Aksi dari komponen utama

/**
 * Komponen PinisiStartScreen menampilkan layar judul, animasi,
 * dan tombol utama untuk memulai permainan atau kembali ke menu global.
 * @param {object} props
 * @param {function} props.dispatch - Fungsi dispatch dari useReducer untuk mengirim aksi.
 * @param {function} props.onGoHome - Fungsi callback untuk kembali ke menu utama aplikasi.
 */
function PinisiStartScreen({ dispatch, onGoHome }) {
    
    // Fungsi untuk menangani klik tombol "Mulai"
    const handleStartGame = () => {
        // Di sini Anda bisa menambahkan logika lain seperti memainkan suara
        dispatch({ type: ACTIONS.START_GAME });
    };

    return (
        <div className={`${styles.screen} ${styles.startScreen} ${styles.active}`}>
            {/* Lapisan untuk animasi ombak di latar belakang */}
            <div className={styles.oceanWaves}>
                <div className={styles.wave}></div>
                <div className={styles.wave}></div>
            </div>

            {/* Konten utama yang berada di atas ombak */}
            <div className={styles.titleContainer}>
                <div className={styles.pinisiHero}>
                    {/* Menggunakan komponen SVG yang sudah dibuat */}
                    <PinisiShipSVG className={styles.pinisiShip} />
                </div>

                <h1 className={styles.mainTitle}>ASAH OTAK ASAH KATA</h1>
                <p className={styles.subtitle}>Guru Inspiratif</p>

                <button className={styles.startButton} onClick={handleStartGame}>
                    MULAI PETUALANGAN
                </button>

                {/* Tombol ini kembali ke menu utama (pemilihan game) */}
                <button 
                    className={`${styles.woodButton} ${styles.backButton}`} 
                    style={{ position: 'static', marginTop: '30px', maxWidth: '300px' }} 
                    onClick={onGoHome}
                >
                    Kembali ke Menu Game
                </button>
            </div>
        </div>
    );
}

export default PinisiStartScreen;